import React, {useEffect, useState} from 'react';
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Link} from "react-router-dom";
import * as management from "../../../actions/management";
import * as auth from "../../../actions/auth";
import connect from "react-redux/lib/connect/connect";


const RoleFunctions = props => {
    const [roleLkpFunctions, setRoleLkpFunctions] = useState([]);
    const [textDetailPopupVisible, setTextDetailPopupVisible] = useState(false);
    const [textDetailText, setTextDetailText] = useState('');
    const [textDetailHeader, setTextDetailHeader] = useState('');

    useEffect(() => {
        getRoleFunctions();

    }, []);

    const getRoleFunctions = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            fetch('/api/role/role_function/list/', {headers,})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        let data = res.data;
                        if (data.result === 0) {
                            //showError(data.message)
                        } else {
                            setRoleLkpFunctions(data)
                        }

                    } else if (res.status === 401) {
                        props.loadUser();
                        throw res.data;
                    } else if (res.status === 403) {
                        throw res.data;
                    }
                })
        }
    }

    const mdNameTemplate = (rowData) => {
        console.log(rowData, "---")
        const md_color = rowData.md.md_color;
        return (
            <div>
                <span style={{fontSize: '10px', background: md_color}} className="p-badge">{rowData.md.md_name}</span>
            </div>
        )
    }

    const rlfDetail = (rowData) => {
        return <div>
            {textSummary(rowData['rfun_detail'], rowData['rfun_name'])}
        </div>
    }

    const textSummary = (str, header) => {
        if (str.length > 100) {
            return <div>
                {str.substring(0, 100)}...
                <Link onClick={() => textDetail(str, header)} to="#"> Devamını Gör </Link>
            </div>
        } else {
            return str
        }
    }

    const textDetail = (fulltext, text_header) => {
        setTextDetailPopupVisible(true);
        setTextDetailText(fulltext);
        setTextDetailHeader(text_header);
    }

    return (
        <div>
            <DataTable
                value={roleLkpFunctions}
                selectionMode="single"
                emptyMessage="Kayıt bulunamadı"
                header="Rol Fonksiyonları"
                paginator={true}
                rows={12}
                responsive={true}>
                <Column
                    field="rfun_id"
                    style={{textAlign: 'center'}}
                    header="No"
                    sortable={true}
                    filter={true}
                />
                <Column
                    style={{textAlign: 'center'}}
                    field="rfun_name"
                    filterMatchMode="contains"
                    header="Fonksiyon Adı"
                    sortable={true}
                    filter={true}
                />
                <Column
                    style={{textAlign: 'center'}}
                    field="md_name"
                    filterMatchMode="contains"
                    body={mdNameTemplate}
                    header="Modül"
                    sortable={true}
                    filter={true}
                />

                <Column
                    field="rfun_detail"
                    style={{textAlign: 'center'}}
                    body={rlfDetail}
                    filterMatchMode="contains"
                    header="Açıklama"
                    sortable={true}
                    filter={true}/>
            </DataTable>
        </div>
    )

}
const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        putMethod: (data, url, type) => {
            return dispatch(management.putMethod(data, url, type));
        },
        postMethod: (data, url, type) => {
            return dispatch(management.postMethod(data, url, type));
        },
        deleteMethod: (data, url, type) => {
            return dispatch(management.deleteMethod(data, url, type));
        },
        logout: () => dispatch(auth.logout()),
        loadUser: () => {
            return dispatch(auth.loadUser());
        },

    }
};


export default connect(mapStateToProps, mapDispatchToProps)(RoleFunctions);


// WEBPACK FOOTER //
// ./src/pages/rolemanagement/components/RoleFunctions.jsx